import cx from "classnames";
import { FlexBox } from "components";
import React, { lazy, useEffect } from "react";
import "./styles.scss";
import { ChartProps } from "./types";
// import Chart from "react-apexcharts";
const Chart = lazy(() => import("react-apexcharts"));

const Charts: React.FC<ChartProps> = ({ className, data }) => {
  const options = {
    colors: ["var(--theme)"],
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        gradientToColors: ["var(--light-theme)"],
        inverseColors: false,
        opacityFrom: 0.8,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    chart: {
      id: "apexchart-example",
    },
    xaxis: {
      categories: data?.reduce((acc, curr) => [...acc, curr.date], []),
    },
  };
  const series = [
    {
      name: "Total",
      data: data?.reduce((acc, curr) => [...acc, curr.countOfApplication], []),
    },
  ];
  return (
    <div className="chart mr-t-40">
      <Chart options={options} series={series} type="area" height={400} />
    </div>
  );
};
export default Charts;
